import React, { useState, useRef, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Classes from './RecordTable.module.css';
import DeleteConfirmPopup from '../../../../../../../../GlobalComponents/DeleteConfirmPopup/DeleteConfirmPopup';
import { useSelector } from 'react-redux';
import backend from '../../../../../../../../../api';

export default function MoreDropDown({ bookingId, doc, onDeleted, onDownload }) {
  const [dropDown, setDropDown] = useState(false);
  const dropdownRef = useRef(null);
  const { token } = useSelector((s) => s?.auth || {});
  const headers = token ? { Authorization: `Bearer ${token}` } : undefined;

  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropDown(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const [openConfirmPopup, setopenConfirmPopup] = useState(false);
  const handleCloseConfirmPopup = () => setopenConfirmPopup(false);
  const handleOpenConfirmPopup = () => setopenConfirmPopup(true);

  const handleConfirmSubmit = async () => {
    try {
      if (!bookingId || !doc?._id) return;
      await backend.delete(`/api/bookings/${bookingId}/documents/${doc._id}`, { headers });
      setopenConfirmPopup(false);
      onDeleted?.();
    } catch (err) {
      alert(err?.response?.data?.error || err.message);
    }
  };

  return (
    <>
      <div className={Classes.dropDown} ref={dropdownRef}>
        <div className="flexAlign10 pointer mr10" onClick={() => setDropDown(!dropDown)}>
          <div className={Classes.dropdownIcon}>
            <svg xmlns="http://www.w3.org/2000/svg" height='15px' viewBox="0 0 128 512">
              <path d="M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z" />
            </svg>
          </div>
        </div>

        <AnimatePresence>
          {dropDown && (
            <motion.div
              initial={{ opacity: 0, y: -5 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -5 }}
              transition={{ duration: 0.15 }}
              className={Classes.dropDownBody}
              style={{ top: '13px', right: '30px' }}
            >
              <div className={Classes.dropDownBodyInner}>
                <div
                  className={Classes.dropDownElem}
                  style={{ padding: '5px 10px' }}
                  onClick={() => {
                    onDownload?.();
                    setDropDown(false);
                  }}
                >
                  <h5>Download</h5>
                </div>
                <div className={Classes.dropDownLine}></div>
                <div
                  className={Classes.dropDownElem}
                  style={{ padding: '5px 10px', color: 'red' }}
                  onClick={() => {
                    handleOpenConfirmPopup();
                    setDropDown(false);
                  }}
                >
                  <h5>Delete</h5>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
        <input type="hidden" aria-label="Without label" readOnly />
      </div>

      <AnimatePresence>
        {openConfirmPopup && (
          <DeleteConfirmPopup
            handleClose={handleCloseConfirmPopup}
            handleSubmit={handleConfirmSubmit}
          />
        )}
      </AnimatePresence>
    </>
  );
}
